
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment/bit",
      function () {
        return require("private-next-pages/payment/bit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment/bit"])
      });
    }
  